import { ButtonGroup, ModalBody, Td, Tr } from "@chakra-ui/react";
import { Dash, IconButton, Modal, Scope, Table } from "components";
import { useConsultant } from "hooks";

export default function Accounts({ data, ...props }){

    const consultant = useConsultant(data?.consultant?.id)

    const columns = [
        { children: 'Banco' }, 
        { children: 'Titular' }, 
        { children: 'Agência' }, 
        { children: 'Conta' }, 
        { children: 'PIX' }
    ]

    return(
    <Modal size="xl" title={`Contas bancárias de ${consultant?.data?.customer?.name}`} {...props}>
        <ModalBody>
            <Table columns={columns} children={ consultant?.data?.customer?.bank_accounts?.map(item => <Item key={item.id} data={item} />)} />
        </ModalBody>
    </Modal>
    )
}

const Item = ({ data:item, ...props }) => (
    <Tr {...props}>
        <Td children={item?.bank?.name ?? <Dash />} />
        <Td textTransform="capitalize" children={item.name} />
        <Td children={<Dash children={item.agency} />} />
        <Td children={<Dash children={item.account} />} />
        <Td children={<Dash children={item.pix_key} />} />
    </Tr>
)